module.exports = __webpack_public_path__ + "static/media/success.4ccb8afa.png";